import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import CollapsibleItem from '@/layout/collapsible/CollapsibleItem.vue';
import { CollapsableModel } from '@/../../EshJSLib/models/CollapsableModel';
import { ColumnModel } from '@/../../EshJSLib/models/ColumnModel';
import { patientStore } from '@/store/patient'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue';
import schemacentriLabaratorioAnalisi from '@/../../EshJSLib/models/form/centriLabaratorioAnalisi.json'
import schemacentriStudiradiologici from '@/../../EshJSLib/models/form/centriStudiradiologici.json'
import schemacentriStudispecialistici from '@/../../EshJSLib/models/form/centriStudispecialistici.json'
import { Modal } from 'flowbite-vue'
import { reactive, ref } from "vue";
import SendCentriEmail from '../views/CentriConvenzionati/SendCentriEmail.vue';
import EmailModal from "@/components/EmailModal.vue";
import AlertModal from "@/components/AlertModal.vue";

interface ModalStatus {
  email: boolean;
  alert: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CentriConvenzionati',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store)
let CentEmail = ref('');
const CentName = ref('');
let CentWeb = ref('');
const alertStatus = ref('');

onMounted(async () => {
  store.fetchCentri();
})

function action(type: string, row: any, index: number, table: string) {
  switch (type) {
    case 'envelope':
      CentEmail.value = row.table_data.table_column_text.value;
      CentName.value = row.table_data.table_column_title.value;
      isShowModal.email = true;
    break;

    case 'globe':
      CentWeb.value = row.table_data.sitoWeb
      openLink(CentWeb.value);
    break;
  }
}

const openLink = (url: string) => {
  console.log('URL passato a openLink:', url);
  if (!url) {
    alert('URL non valido o mancante!');
    return;
  } else {
    window.open(url, '_blank');
  }
};

function search(word: string, check: boolean, tipo: string) {
  if (check) {
    patient.value[tipo] = patient.value[tipo]?.filter((datas) =>
      datas.centro_nome.toLowerCase().includes(word.toLowerCase()) || datas.centro_indirizzo.toLowerCase().includes(word.toLowerCase())
    );
  } else {
    patient.value[tipo] = null;
    store.fetchCentri();
  }
}

const isShowModal: ModalStatus = reactive({
  email: false,
  alert: false
});
function closeModal() {

  isShowModal.email = false;
}

function alert(status: string) {
  isShowModal.email = false;
  alertStatus.value = status;
  isShowModal.alert = true;

}

const dataModelCompletati = new CollapsableModel();

return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isShowModal.email == true)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 0,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (isShowModal.email = false))
            }, {
              header: _withCtx(() => [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Nuova Email')), 1)
              ]),
              body: _withCtx(() => [
                _createVNode(EmailModal, {
                  reciever: _unref(CentEmail),
                  "reciever-name": CentName.value,
                  onCancelMail: _cache[0] || (_cache[0] = ($event: any) => (isShowModal.email = false)),
                  onAlert: _cache[1] || (_cache[1] = (status) => alert(status))
                }, null, 8, ["reciever", "reciever-name"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isShowModal.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 1,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (isShowModal.alert = false))
            }, {
              body: _withCtx(() => [
                _createVNode(AlertModal, {
                  status: alertStatus.value,
                  onCloseAlert: _cache[3] || (_cache[3] = ($event: any) => (isShowModal.alert = false))
                }, null, 8, ["status"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(CollapsibleItem, {
          data: _unref(schemacentriStudispecialistici),
          onRowActions: _cache[5] || (_cache[5] = (n, r, i) => action(n, r, i, 'Studispecialistici')),
          onSearch: _cache[6] || (_cache[6] = (w, c) => search(w, c, 'centri_convenzionati_specialistici'))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          data: _unref(schemacentriStudiradiologici),
          onRowActions: _cache[7] || (_cache[7] = (n, r, i) => action(n, r, i, 'Studiradiologici')),
          onSearch: _cache[8] || (_cache[8] = (w, c) => search(w, c, 'centri_convenzionati_radiologici'))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          data: _unref(schemacentriLabaratorioAnalisi),
          onRowActions: _cache[9] || (_cache[9] = (n, r, i) => action(n, r, i, 'LabaratorioAnalisi')),
          onSearch: _cache[10] || (_cache[10] = (w, c) => search(w, c, 'centri_convenzionati_laboratory_analisi'))
        }, null, 8, ["data"])
      ]))
    : _createCommentVNode("", true)
}
}

})